import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import ReactDOM from "react-dom";
import { ModalContext } from "components/ModalContext";
import { CSSTransition } from "react-transition-group";
import "./index.scss";
import { dragAndDropElement } from "../../../utils/helpers";

const Modal = ({
  onCloseModal,
}) => {
  const { 
    modalContent,
    handleModal, 
    modal,
    isDragAndDrop
  } = React.useContext(ModalContext);

  const modalContentElement = useRef();

  useEffect(() => {
    if(modalContentElement.current && isDragAndDrop) {
      dragAndDropElement(modalContentElement.current);
    }
  }, [modal]);

  useEffect(() => {
    const body = document.body;
    
    modal
      ? (body.style.overflow = "hidden")
      : (body.style.overflow = "unset");
  }, [modal]);

  const handleCloseModal = (e) => {
    if (
      [...e.target.classList].includes('modal_wrap')
      || [...e.target.classList].includes('modal_close')
    ) {
      handleModal();
      onCloseModal();
    }
  };

  return ReactDOM.createPortal(
    <CSSTransition
      in={!!modal}
      timeout={300}
      classNames="modal_wrap"
      unmountOnExit
    >
      <>
        <div
          className="modal_wrap"
          onClick={handleCloseModal}
          style={isDragAndDrop && {background: "none", pointerEvents: "none"}}
        >
          <div
            className="modal_content"
            ref={modalContentElement}
            style={isDragAndDrop && {pointerEvents: "auto"}}
          >
            <button
              className="modal_close"
              onClick={handleCloseModal}
            >
              &times;
            </button>

            <div
              className="modal_content_body"
            >
              {modalContent}
            </div>
          </div>
        </div>
      </>
    </CSSTransition>,
    document.querySelector("#modals")
  );
};

export default Modal;
